import {Icon} from '../../../icon'
import {Layout} from '../../../layout'
import {Text} from '../../../text'
import {useBasicTableContext} from '../../context'

export const BasicTableHeaderCell = ({column}) => {
	const {updateSort, defaultSortField, basicTableT} = useBasicTableContext()
	const {id, docsId, tooltip, popout, label, style} = column
	const hasPopout = tooltip || docsId

	const clickColumn = () => updateSort(id)

	const infoIconMessage = hasPopout && {
		type: docsId && 'docs',
		docsId,
		title: popout?.title || basicTableT([`${id}.popout.title`, `${id}.title`]),
		body: popout?.body || basicTableT(`${id}.popout.body`),
	}

	return (
		<Layout
			data-intercom-target={`basic-table-column-${id}`}
			className="basic-table-header-cell"
			onClick={defaultSortField && clickColumn}
			background="light-grey"
			padding={16}
			height={40}
			style={style}
		>
			<SortIcon columnId={id} />
			<Layout grow>
				<Text black truncate semiBold noTextSelect infoIconMessage={infoIconMessage}>
					{label || basicTableT(`${id}.title`)}
				</Text>
			</Layout>
		</Layout>
	)
}

const SortIcon = ({columnId}) => {
	const {sortDirection, sortField} = useBasicTableContext()
	if (columnId !== sortField) return null
	return <Icon name={sortDirection === 'asc' ? 'arrow-up' : 'arrow-down'} size={14} />
}
